import React from "react";
import { ToastContainer, ToastStore } from "react-toasts";
import axios from "axios";
import { Table } from "reactstrap";

import "./FrameImages.css";
import "./MediaManager.css";

/* eslint-disable import/no-webpack-loader-syntax */

import AddIcon from "-!svg-react-loader!../icons/add.svg";
import RemoveIcon from "-!svg-react-loader!../icons/trash.svg";

import utilities from "./Utilities";
let Utilities = new utilities();

export default class FrameImages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: undefined,
      headers: undefined,
      images: undefined
    };
  }

  getMedia = () => {
    let user = localStorage.getItem("user");

    if (!user) {
      window.location.href = "/login";
      return;
    }

    user = JSON.parse(user);

    if (user.type !== 1) {
      window.location.href = "/login";
      return;
    }

    axios.get(`/api/admin-settings/frame`).then(res => {
      console.log("GOT FRAMES", res.data.data);
      this.setState({
        items: res.data.data
      });
    });

    console.log("GETTING ++++++++++", this.state.singleEdit);

    window.globalVars.server.api({
      method: "get",
      url: "/api/frame-image/" + this.state.singleEdit,
      data: {},
      then: function(res) {
        if (Utilities.isENU(res.data.data)) {
          ToastStore.error("Coudln't get frame images");
        } else {
          console.log("GOT FRAME IMAGES", res.data.data);
          this.setState({
            images: res.data.data.images,
            headers: res.data.data.headers
          });
        }
      }.bind(this),
      catch: function(e) {
        ToastStore.error("Coudln't get user");
      }.bind(this)
    });
  };

  componentDidMount() {
    document.title =
      window.globalVars.pageTitleBefore +
      "Frame Image Manager" +
      window.globalVars.pageTitleAfter;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    let frameId = window.location.href;
    frameId = frameId.substr(frameId.lastIndexOf("/") + 1);

    if (frameId !== "frame-images") {
      this.setState(
        {
          singleEdit: frameId
        },
        function() {
          this.getMedia();
        }
      );
    } else {
      this.getMedia();
    }
  }

  triggerUploadDialog = () => {
    var event = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: false
    });

    var node = document.getElementById("profile-picture-upload-input");
    node.dispatchEvent(event);
  };

  delete = (type, id, headerId) => {
    console.log(type, id);

    window.globalVars.server.api({
      method: "delete",
      url: "/api/frame-image/delete/" + type + "/" + id + "/" + headerId,
      data: {},
      then: function(res) {
        window.location.reload();
      }.bind(this),
      catch: function(e) {
        window.location.reload();
      }.bind(this)
    });
  };

  onChange(e) {
    Utilities.getBase64(e.target.files[0])
      .then(
        function(base64) {
          console.log("UPloading");

          window.globalVars.server.api({
            method: "post",
            url: "/api/frame-image/upload/",
            data: {
              base64Content: base64,
              nextType: this.state.nextType,
              nextHeaderId: this.state.nextHeaderId,
              nextFrameId: this.state.nextFrameId,
              headerFrameId: this.state.singleEdit
            },
            then: function(res) {
              if (res.data.success === false) {
                ToastStore.error(res.data.data);
              } else {
                ToastStore.success(res.data.data);
                setTimeout(function() {
                  window.location.reload();
                }, 2000);
              }
            }.bind(this),
            catch: function(e) {
              //window.location.reload();
            }.bind(this)
          });
        }.bind(this)
      )
      .catch(function(err) {}.bind(this));
  }

  render() {
    return (
      <div className='media-manager-container'>
        <div className='main-container'>
          <div className='frame-images media-manager'>
            <h1>{this.props.title}</h1>
            {this.state.items === undefined && <p>Loading</p>}
            {this.state.items !== undefined &&
              this.state.items.length === undefined && <p>No Items</p>}
            {this.state.items !== undefined &&
              this.state.headers !== undefined && (
                <div>
                  <Table>
                    <thead>
                      <tr>
                        <th>Thumbnails</th>
                        {this.state.headers
                          .concat({ _id: 12, type: "header", name: "new" })
                          .map(item => {
                            return (
                              <th>
                                {item.name === "new" ? (
                                  <button
                                    className='upload-btn'
                                    onClick={() => {
                                      this.setState(
                                        {
                                          nextType: "header",
                                          nextHeaderId: null
                                        },
                                        function() {
                                          this.triggerUploadDialog();
                                        }
                                      );
                                    }}
                                  >
                                    <AddIcon />
                                  </button>
                                ) : (
                                  <div>
                                    <div className='img'>
                                      <img
                                        src={
                                          "https://s3-ap-southeast-1.amazonaws.com/frameitsg/frame-images/header-" +
                                          item.name
                                        }
                                      />
                                    </div>
                                    <button
                                      className='remove-btn'
                                      onClick={() => {
                                        if (
                                          window.confirm(
                                            "Are you sure you want to delete this category, this will delete all frames in this category as well."
                                          )
                                        ) {
                                          this.delete("header", item._id);
                                        }
                                      }}
                                    >
                                      <RemoveIcon />
                                    </button>
                                  </div>
                                )}
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.items.map(frame => {
                        if (
                          this.state.singleEdit &&
                          this.state.singleEdit !== frame.adminId
                        ) {
                          return null;
                        }

                        return (
                          <tr data-id={frame.adminId}>
                            <td scope='row'>Frame id: {frame.adminId}</td>
                            {this.state.headers
                              .concat({ _id: 12, type: "header", name: "new" })
                              .map(item => {
                                return (
                                  <th>
                                    {item.name === "new" ? null : (
                                      <div>
                                        {this.state.images[
                                          item._id + "-" + frame._id
                                        ] ? (
                                          <div>
                                            <div className='img'>
                                              <img
                                                src={
                                                  "https://s3-ap-southeast-1.amazonaws.com/frameitsg/frame-images/image-" +
                                                  item._id +
                                                  "-" +
                                                  frame._id +
                                                  "-" +
                                                  this.state.images[
                                                    item._id + "-" + frame._id
                                                  ]
                                                }
                                              />
                                            </div>
                                            <button
                                              className='remove-btn'
                                              onClick={() => {
                                                if (
                                                  window.confirm(
                                                    "Are you sure you want to delete this category, this will delete all frames in this category as well."
                                                  )
                                                ) {
                                                  this.delete(
                                                    "image",
                                                    frame._id,
                                                    item._id
                                                  );
                                                }
                                              }}
                                            >
                                              <RemoveIcon />
                                            </button>
                                          </div>
                                        ) : (
                                          <button
                                            className='upload-btn'
                                            onClick={() => {
                                              this.setState(
                                                {
                                                  nextType: "image",
                                                  nextHeaderId: item._id,
                                                  nextFrameId: frame._id
                                                },
                                                function() {
                                                  this.triggerUploadDialog();
                                                }
                                              );
                                            }}
                                          >
                                            Upload
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </th>
                                );
                              })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              )}
          </div>
        </div>
        <input
          id='profile-picture-upload-input'
          type='file'
          name='profile-picture'
          onChange={e => {
            this.onChange(e);
          }}
        />
        <ToastContainer store={ToastStore} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FrameImages.js